import React from "react";
import styles from "./ui-element.module.scss";

const Card = (props) => {
  return (
    <div {...props} className={`${styles.card} ${props.className}`}>
      {props.children}
    </div>
  );
};

export default Card;
